import React from "react";
import { Button, Popover, SelectBox, TextBox, NumberBox } from "devextreme-react";
import { filterType } from "../../helpers/filterHelper";
import { any } from "prop-types";


class NumberRangeFilter extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      desde: undefined,
      hasta: undefined,
      desdeValid: true,
      hastaValid: true
    };
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.selectedValues.length !== this.props.selectedValues.length
      && prevProps.selectedValues.length > this.props.selectedValues.length) {
      this.setState({ desde: undefined, hasta: undefined });
    }
  }

  handleOpenClose = (open) => {
    this.setState({ open });
  }

  handleCancel = () => {
    this.setState({ open: false, hasta: undefined, desde: undefined });
    this.handleFilter();
  }

  handleFilter = () => {
    const {
      desde,
      hasta,
    } = this.state;

    let filterValue;
    if (desde != null && hasta != null) {
      filterValue = {
        text: `${this.props.filterText}: ${this.state.desde} - ${this.state.hasta}`,
        value: {
          from: desde,
          to: hasta,
        }
      };
    }

    this.setState({ open: false });
    this.props.onFilter([{
      column: this.props.column,
      type: filterType.number,
      value: filterValue,
    }]);
  }

  handleChangeNumberMin = (e) => {
    this.setState({ desde: e.value, desdeValid: true, hastaValid: true });

    if (this.state.hasta && this.state.hasta > 0) {
      if (e.value > this.state.hasta)
        this.setState({ desdeValid: false });
      else
        this.setState({ desdeValid: true });
    }
  }

  handleChangeNumberMax = (e) => {
    this.setState({ hasta: e.value, hastaValid: true, desdeValid: true });

    if (this.state.desde && this.state.desde > 0) {
      if (e.value < this.state.desde)
        this.setState({ hastaValid: false });
      else
        this.setState({ hastaValid: true });
    }
  }

  render() {
    const { format } = this.props;

    return (
      <React.Fragment>
        <SelectBox
          onInitialized={e => {
            e && e.component && e.component.option("openOnFieldClick", false);
          }}
          displayExpr="Name"
          id={this.props.column}
          className="select-table-filter"
          fieldComponent={props => (
            <div
              className="select-table-filter-field"
              onClickCapture={() => this.handleOpenClose(!this.state.open)}
            >
              <span>{this.props.filterText}</span>
              <TextBox readOnly visible={false} />
              <i className="dx-icon dx-icon-filter" />
            </div>
          )}
        />
        <Popover
          onHiding={() => this.setState({ open: false })}
          closeOnOutsideClick
          visible={this.state.open}
          width={250}
          target={`#${this.props.column}`}
          position={{ offset: "0 16", my: "top" }}
          animation={{
            show: {
              type: "pop",
              duration: 0,
            },
          }}
        >
          <NumberBox
            value={this.state.desde}
            showSpinButtons
            showClearButton
            format={format ? format : '$ #,##0.##'}
            mode="text"
            placeholder="Mínimo"
            onValueChanged={this.handleChangeNumberMin}
            isValid={this.state.desdeValid}
            validationError={{ message: "Valor mínimo es mayor al valor máximo" }}
          />
          <NumberBox
            value={this.state.hasta}
            showSpinButtons
            showClearButton
            placeholder="Máximo"
            format={format ? format : '$ #,##0.##'}
            style={{ marginTop: 10 }}
            onValueChanged={this.handleChangeNumberMax}
            isValid={this.state.hastaValid}
            validationError={{ message: "Valor máximo es menor al valor mínimo" }}



          />
          <div style={{ marginTop: 10 }}>
            <Button text="Cerrar" onClick={this.handleCancel} />
            <Button
              text="Filtrar"
              className="filter-accept-button"
              disabled={!(this.state.desde != null && this.state.hasta != null) || !(this.state.desde <= this.state.hasta)}
              onClick={this.handleFilter}
            />
          </div>
        </Popover>
      </React.Fragment>
    );
  }
}

export default NumberRangeFilter;
